const initFormFileInputs = (root = document) => {
    const scope = root instanceof Element ? root : document;

    scope.querySelectorAll('[js-form-file-element]').forEach(wrapper => {
        if (wrapper.dataset.formFileInit === '1') {
            return;
        }

        wrapper.dataset.formFileInit = '1';

        const fileLabel = wrapper.querySelector('[js-file-label]');

        wrapper.addEventListener('change', event => {
            const files = event.target.files;

            if (!fileLabel) {
                return;
            }

            if (files.length) {
                fileLabel.textContent = Array.from(files)
                    .map(file => file.name)
                    .join(', ');
            } else {
                fileLabel.textContent = wrapper.dataset.placeholder;
            }
        });
    });
};

initFormFileInputs(document);
window.mdaInitFormFileInputs = initFormFileInputs;
